/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commerce_IntelligencetmInputs */

const en_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Intelligence™`)
};

const es_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia Comercial™`)
};

const fr_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Intelligence™`)
};

const de_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Intelligence™`)
};

const ja_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマース・インテリジェンス™`)
};

const zh_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商务智能 (Commerce Intelligence™)`)
};

const ar_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Intelligence™`)
};

const id_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan Perdagangan™`)
};

const it_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce Intelligence™`)
};

const ru_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коммерческий интеллект (Commerce Intelligence™)`)
};

const pt_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligência de Comércio™`)
};

const ko_commerce_intelligencetm = /** @type {(inputs: Commerce_IntelligencetmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커머스 인텔리전스™`)
};

/**
* | output |
* | --- |
* | "Commerce Intelligence™" |
*
* @param {Commerce_IntelligencetmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const commerce_intelligencetm = /** @type {((inputs?: Commerce_IntelligencetmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commerce_IntelligencetmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_commerce_intelligencetm(inputs)
	if (locale === "es") return es_commerce_intelligencetm(inputs)
	if (locale === "fr") return fr_commerce_intelligencetm(inputs)
	if (locale === "de") return de_commerce_intelligencetm(inputs)
	if (locale === "ja") return ja_commerce_intelligencetm(inputs)
	if (locale === "zh") return zh_commerce_intelligencetm(inputs)
	if (locale === "ar") return ar_commerce_intelligencetm(inputs)
	if (locale === "id") return id_commerce_intelligencetm(inputs)
	if (locale === "it") return it_commerce_intelligencetm(inputs)
	if (locale === "ru") return ru_commerce_intelligencetm(inputs)
	if (locale === "pt") return pt_commerce_intelligencetm(inputs)
	return ko_commerce_intelligencetm(inputs)
});